// JoinChatWidget.jsx
import React, { useState } from "react";

const JoinChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="fixed bottom-6 right-6 z-50 text-white font-sans"
      role="dialog"
      aria-labelledby="joinchat__label"
      aria-modal="true"
    >
      {/* Floating WhatsApp Button */}
      <button
        onClick={() => setIsOpen(true)}
        className={`bg-[#25D366] w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 ease-out transform ${isOpen
            ? "scale-90 opacity-0 pointer-events-none"
            : "hover:scale-105 hover:shadow-2xl"
          }`}
        aria-label="Open WhatsApp Chat"
      >
        {/* ✅ Proper WhatsApp Icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="white"
          viewBox="0 0 24 24"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.967-.273-.099-.472-.149-.672.15-.197.297-.77.966-.944 1.164-.173.198-.347.223-.644.075-.297-.15-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.15-.174.198-.298.298-.497.1-.198.05-.373-.025-.522-.075-.149-.672-1.611-.921-2.205-.242-.58-.487-.501-.672-.51-.173-.009-.372-.01-.571-.01-.198 0-.52.075-.793.373-.273.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.36-.214-3.741.982.999-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.24c.001-5.45 4.436-9.884 9.885-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.896 6.991c-.002 5.45-4.436 9.884-9.887 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.305-1.654a11.882 11.882 0 0 0 5.732 1.46h.005c6.554 0 11.89-5.335 11.893-11.893a11.82 11.82 0 0 0-3.466-8.455" />
        </svg>
      </button>

      {/* Chat Box */}
      {isOpen && (
        <div className="animate-fadeInUp bg-white text-gray-800 rounded-xl shadow-2xl overflow-hidden w-80 mb-3 transition-all">
          {/* Header */}
          <div className="flex justify-between items-center bg-[#25D366] p-3 rounded-t-xl">
            <div id="joinchat__label" className="flex items-center space-x-2 text-white font-medium">
              WhatsApp Chat
            </div>
            <button
              className="text-white text-xl font-semibold hover:rotate-90 transition-transform duration-200"
              onClick={() => setIsOpen(false)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>

          {/* Chat Content */}
          <div className="p-4 space-y-3">
            <div className="bg-[#DCF8C6] rounded-lg px-3 py-2 shadow-sm w-fit">
              Hello 👋 <br />
              Can we help you?
            </div>

            <a
              href="https://wa.me/923129388531?text=Hey!%20I%20want%20to%20inquire%20about%20Isuzu%20vehicles."
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5a] text-white px-4 py-2 rounded-lg font-medium cursor-pointer shadow-md transition-transform duration-200 hover:scale-[1.03]"
            >
              <span>Open chat</span>
              <svg
                width="22"
                height="22"
                viewBox="0 0 400 400"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M168.83 200.504H79.218L33.04 44.284a1 1 0 0 1 1.386-1.188L365.083 199.04a1 1 0 0 1 .003 1.808L34.432 357.903a1 1 0 0 1-1.388-1.187l29.42-99.427" />
                <path d="M318.087 318.087c-52.982 52.982-132.708 62.922-195.725 29.82l-80.449 10.18 10.358-80.112C18.956 214.905 28.836 134.99 81.913 81.913c65.218-65.217 170.956-65.217 236.174 0 42.661 42.661 57.416 102.661 44.265 157.316" />
              </svg>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default JoinChatWidget;
